import axiosInstance from '@/shared/api/axios';
import type {
  ApiRole,
  ApiRoleCreateBody,
  ApiRoleListResponse,
  ApiRoleUpdateBody,
} from '@/shared/types/api/roles';

export const apiRolesList = async (): Promise<ApiRoleListResponse> => {
  const { data } = await axiosInstance.get<ApiRoleListResponse>('/roles');
  return data;
};

export const apiRoleGet = async (id: string): Promise<ApiRole> => {
  const { data } = await axiosInstance.get<ApiRole>(`/roles/${id}`);
  return data;
};

export const apiRoleCreate = async (body: ApiRoleCreateBody): Promise<ApiRole> => {
  const { data } = await axiosInstance.post<ApiRole>('/roles', body);
  return data;
};

export const apiRoleUpdate = async (
  id: string,
  body: ApiRoleUpdateBody,
): Promise<ApiRole> => {
  const { data } = await axiosInstance.patch<ApiRole>(`/roles/${id}`, body);
  return data;
};

export const apiRoleDelete = async (id: string, reassignTo: string): Promise<void> => {
  await axiosInstance.delete(`/roles/${id}`, { params: { reassign_to: reassignTo } });
};
